// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"2af5f3f6","739":"9d611cb0"}[chunkId] + ".chunk.js";
};